/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateSubscriptionInput
 */
export interface UpdateSubscriptionInput {
    /**
     * 
     * @type {string}
     * @memberof UpdateSubscriptionInput
     */
    billingCycle?: UpdateSubscriptionInputBillingCycleEnum;
}


/**
 * @export
 */
export const UpdateSubscriptionInputBillingCycleEnum = {
    Monthly: 'monthly',
    Annual: 'annual'
} as const;
export type UpdateSubscriptionInputBillingCycleEnum = typeof UpdateSubscriptionInputBillingCycleEnum[keyof typeof UpdateSubscriptionInputBillingCycleEnum];


/**
 * Check if a given object implements the UpdateSubscriptionInput interface.
 */
export function instanceOfUpdateSubscriptionInput(value: object): value is UpdateSubscriptionInput {
    return true;
}

export function UpdateSubscriptionInputFromJSON(json: any): UpdateSubscriptionInput {
    return UpdateSubscriptionInputFromJSONTyped(json, false);
}

export function UpdateSubscriptionInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateSubscriptionInput {
    if (json == null) {
        return json;
    }
    return {
        
        'billingCycle': json['billingCycle'] == null ? undefined : json['billingCycle'],
    };
}

export function UpdateSubscriptionInputToJSON(json: any): UpdateSubscriptionInput {
    return UpdateSubscriptionInputToJSONTyped(json, false);
}

export function UpdateSubscriptionInputToJSONTyped(value?: UpdateSubscriptionInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'billingCycle': value['billingCycle'],
    };
}

